<template>
  <div class="ks-form-section">
    <ks-form-divider>{{ label }}</ks-form-divider>
    <div class="form-section" :class="[sectionClass]">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import KsFormDivider from './KsFormDivider.vue'

  export default {
    name: 'ks-form-section',
    components: {
      KsFormDivider,
    },
    props: {
      label: {
        type: String,
        default: '',
      },
      sectionClass: {
        type: String,
        default: '',
      },
    },
  }
</script>
